module.exports = __webpack_public_path__ + "static/media/templateGuest.34ff68f8.xlsx";